export default __webpack_public_path__ + "static/media/blog4_image.d0e4679a.png";